import { createReducer, PayloadAction } from "typesafe-actions"

import { NoApartmentState } from "../types/store.types"
import { FormStatuses } from "@theguarantors/frontend-core/dist/types/formik"
import { NoApartmentFormSubmitAction } from "../types/actions"
import { SUBMIT_FORM_REQUEST, SUBMIT_FORM_SUCCESS, SUBMIT_FORM_FAILURE } from "../actions/noApartment"

const initialState: NoApartmentState = {
  error: null,
  status: FormStatuses.form
}

export default createReducer<NoApartmentState, NoApartmentFormSubmitAction>(initialState, {
  [SUBMIT_FORM_REQUEST]: () => ({
    ...initialState
  }),
  [SUBMIT_FORM_SUCCESS]: () => ({
    ...initialState,
    status: FormStatuses.success
  }),
  [SUBMIT_FORM_FAILURE]: (state: NoApartmentState, action: PayloadAction<string, string>) => ({
    ...state,
    error: action.payload,
    status: FormStatuses.error
  })
})
